import React from "react";
import CommonSelect from "../common/commonSelect";
// import CommonSelect from "../../../core/common/commonSelect";

interface EditCredentialsModalProps {
  modalId: string;
  onSubmit: () => void;
  credentialsForm: {
    provider: string;
    email: string;
    password: string;
  };
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
}

const providers = [
  { value: "gmail", label: "Gmail" },
  { value: "hostinger", label: "Hostinger" },
  // Add more providers as needed
];

const EditCredentialsModal: React.FC<EditCredentialsModalProps> = ({
  modalId,
  onSubmit,
  credentialsForm,
  handleInputChange,
}) => {
  return (
    <div className="modal fade" id={modalId}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Edit Credentials</h4>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="edit_credentials_modal_close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label className="form-label">
                  Provider <span className="text-danger">*</span>
                </label>
                <CommonSelect
                  className="select"
                  options={providers}
                  defaultValue={
                    providers.find(
                      (p) => p.value === credentialsForm.provider
                    ) || undefined
                  }
                  onChange={(selectedOption: any) =>
                    handleInputChange({
                      target: { name: "provider", value: selectedOption.value },
                    } as any)
                  }
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={credentialsForm.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Password <span className="text-danger">*</span>
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={credentialsForm.password}
                  onChange={handleInputChange}
                />
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCredentialsModal;
